
import { Component, Prop, Vue } from 'vue-property-decorator';

import { getPartsList } from '@/api/parts';
import { UserModule } from '@/store/modules/user';

@Component({
  name: 'PartsChildrenList',
  filters: {
    getSource(val: any) {
      let t = '';
      switch (parseInt(val)){
        case 1:
          t='公司';
          break;
        case 3:
          t='工程师';
          break;
        default:
          t='';
          break;
      }
      return t;
    }
  }
})
export default class extends Vue {
  // 当前层级的名称列表
  @Prop({
    type: Array,
    default: () => []
  })
  list!: any[];

  // 当前列表的父级名称 id（用于刷新当前层级）
  @Prop({
    type: [String, Number],
    default: ''
  })
  pid!: any;

  // 展开行：懒加载下级名称（名称列表接口传 pid 获取）
  private handleExpandChange(row: any, expandedRows: any[]) {
    const expanded = expandedRows.some((item: any) => item.id === row.id);
    if (expanded && parseInt(row.children_count) > 0 && !row.childrenx) {
      this.fetchChildren(row);
    }
  }

  private fetchChildren(row: any) {
    const params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      pid: row.id,
      is_need_child_count: 1,
      page: 1,
      size: 9999
    };
    getPartsList(params)
      .then((res: any) => {
        const data = res.data;
        this.$set(row, 'childrenx', data && data.list ? data.list : []);
      })
      .catch((err: any) => {
        let msg = err.msg;
      });
  }

  // 刷新当前层级列表
  private refreshList() {
    const params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      pid: this.pid,
      is_need_child_count: 1,
      page: 1,
      size: 9999
    };
    getPartsList(params)
      .then((res: any) => {
        const data = res.data;
        const list = data && data.list ? data.list : [];
        this.list.splice(0, this.list.length, ...list);
      })
      .catch((err: any) => {
        let msg = err.msg;
      });
  }

  private emitEditName(row: any) {
    this.$emit('edit-name', row, () => this.refreshList());
  }

  private emitAddChild(row: any) {
    this.$emit('add-child', row, () => this.refreshList());
  }

  private emitAddModel(row: any) {
    this.$emit('add-model', row, () => this.refreshList());
  }

  private emitDeleteName(row: any) {
    this.$emit('delete-name', row, () => this.refreshList());
  }

  private emitEditModel(model: any, name: any) {
    this.$emit('edit-model', model, name, () => this.refreshList());
  }

  private emitDeleteModel(model: any, name: any) {
    this.$emit('delete-model', model, name, () => this.refreshList());
  }

  private imgLargeHandle(val: [], index: number) {
    let enlargedData = {
      isShow: true,
      imgList: [val],
      initNum: index
    };
    this.$store.dispatch('toggleEnlarged', enlargedData);
  }
}
